<template lang="pug">
.page
  section#options
    .container
      .row.header
        .col-12
          h1 We've heard your feedback
          // p Purchase more Sprites to adopt and add to your collection. There are a variety of types of Sprites who all evolve into unique and engaging forms with their own personalities and abilities, and each Sprite you adopt will be an exciting surprise!
          p
            span(style='margin-right: .2rem;') We are working on a new way to acquire sprites! Follow updates on
            a(href='https://discord.gg/zNrhQ3t', target='_blank') Discord
      .row
        .col-12.col-md-4.offset-md-4
          .buy-item
            div
              img.egg(src='../assets/egg_forest_sprite.svg')
              img.island(src='../assets/island-1@3x.png')
            //button.btn.btn-green Coming Soon
  //section#nav
    .decor-border
      img(src='../assets/landing-page/white-border.svg')
    .container
      .tabs.d-flex.align-items-center.justify-content-center
        .tab(@click='scrollTo("#why-title")') Why Purchase
        .tab(@click='scrollTo("#perks-title")') Additional Perks
        .tab(@click='scrollTo("#started-title")') Getting Started
  //section#why
    .container
      .row
        h2#why-title.col-12 Why Purchase?
      .row
        img.divider(src='../assets/landing-page/divider.svg')
      .row
        .col-12.col-md-6
          img(src='../assets/market/baby-sprite-rainbow@3x.png')
          p Baby Sprites sure are cute, but exciting transformations are in store as they grow and evolve! Each Sprite’s evolution and final form will be a surprise.
        .col-12.col-md-6
          img(src='../assets/market/royal-sprite@3x.png')
          p You can collect whole families of Sprites and even special Royal Sprites! Each Sprite has its own personality and charming look.
      .row
        .col-12.col-md-6
          img(src='../assets/market/sell-sprites@3x.png')
          p Once you own a Sprite, you can buy and sell it on the blockchain! Complete your collection and help fellow players complete theirs.
        .col-12.col-md-6
          img(src='../assets/market/support-habitica@3x.png')
          p Your purchase supports the Habitica team and helps us add more exciting features to Spritely.
      .row
        .col-12
          h3 You’ll get exclusive rewards in Habitica!
          p Purchasing a Sprite gets you a Sprite Hat, while purchasing three Sprites nets you the hat as well as a baby Sprite Pet. If you buy five Sprites, you’ll receive the hat and pet, plus a Sprite mount to complete your look and a bonus Hazelnut Helm to set you apart from the crowd!
      .row.rewards
        .col-12.col-md-4
          img(src='../assets/market/tier-1@3x.png')
          .title Own a Sprite
          p Sprite Hat
        .col-12.col-md-4
          img(src='../assets/market/tier-2@3x.png')
          .title Own 3 Sprites
          p Sprite Hat and baby Sprite Pet
        .col-12.col-md-4
          img(src='../assets/market/tier-3@3x.png')
          .title Own 5 Sprites
          p Hazelnut Helm and Sprite mount
  //section#perks
    .container
      .row
        img.divider(src='../assets/landing-page/divider.svg')
      .row
        h2#perks-title.col-12 Additional Perks
        p.sub-title.col-12 As an early adopter and supporter, you’ll receive fantastic perks!
        .col-12.col-md-6.offset-3.d-flex.align-items-center
          img(src='../assets/market/bullet.svg')
          p Get early access pricing and get a head-start on building your Sprite collection.
        .col-12.col-md-6.offset-3.d-flex.align-items-center
          img(src='../assets/market/bullet.svg')
          p Your feedback and feature requests will be an important force in helping us shape the direction of Spritely and build an even larger and more engaging world for you and your Sprites.
        .col-12.col-md-6.offset-3.d-flex.align-items-center
          img(src='../assets/market/bullet.svg')
          p You’ll be an official cryptocurrency owner! You can take what you’ve learned in the world of Spritely and explore the new and innovative world of the blockchain- whether for investment, or just for fun!
  //section#getting-started
    .container
      .row
        img.divider(src='../assets/landing-page/divider.svg')
      .row
        h2#started-title.col-12 Getting Started
      .row
        .col-12
          img(src='../assets/market/ethereum.svg')
        h3.col-12 1. Install Metamask
        .col-12
          p To collect Sprites, you will need to install a secure wallet like MetaMask. You will use a wallet to make transactions with ether (ETH), a blockchain-based currency.
        .col-12
          iframe(width="656" height="315" src="https://www.youtube.com/embed/tfETpi-9ORs" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen)
        .col-12
          p Installing MetaMask is easy! It works as a browser extension and can manage multiple wallets for you. Find out more at and download MetaMask at MetaMask.io.
      .row
        .col-12
          img(src='../assets/market/ethereum.svg')
        h3.col-12 2. Add ETH to your Wallet
        .col-12
          p To add ether to your MetaMask wallet, open MetaMask and choose “Main Ethereum Network” from the dropdown in the upper left corner of the menu. Then, select “Buy” from the options displayed with your selected wallet. You will then be given a choice between several services you can use to purchase ETH. For U.S. users, we recommend using the CoinBase widget so you don’t have to create additional accounts.
        .col-12.col-md-6
          img(src='../assets/market/meta-mask-network@3x.png')
        .col-12.col-md-6
          img(src='../assets/market/meta-mask-buy@3x.png')
        .col-12
          p Note: For users outside the U.S., you’ll need to buy ETH from an exchange using a fiat currency (“fiat” refers to a currency backed by a government. Most major world currencies, such as U.S. dollars and Euros, are fiat currencies).
      .row
        .col-12
          img(src='../assets/market/sprite-egg.svg')
        h3.col-12 3. Adopt a Sprite
        .col-12
          p Once you have ETH, you can buy new and exciting Sprites to add to your collection!
        .col-12
          .btn-green(@click='scrollTo("#options")') Back To Top
    .decor-border
      img(src='../assets/market/grey-border.svg')
</template>

<style lang="scss" scoped>
  .divider {
    margin: 3rem auto !important;
    max-width: none !important;
  }

  #options {
    padding-top: 2rem;
    padding-bottom: 5rem;

    .header {
      margin-top: 1rem;
      margin-bottom: 2rem;

      h1 {
        text-transform: uppercase;
        font-size: 24px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.33;
        letter-spacing: 2px;
        text-align: center;
        color: #6c6d69;
      }

      p {
        max-width: 588px;
        margin: 0 auto;
        font-size: 16px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: center;
        color: #6c6d69;
      }
    }

    .item {
      padding: 1em;
      margin-bottom: 1em;
    }

    .page {
      padding-top: 2em;
      min-height: 100vh;
    }

    .card {
      padding: 2em;
      border: none;
      min-height: 150px;
      max-width: 384px;
      margin: 0 auto;
      padding: 2rem;
      border: none;
      border-radius: 8px;
      background-color: #ffffff;
      box-shadow: 0 2px 2px 0 rgba(31, 31, 31, 0.12), 0 0 2px 0 rgba(31, 31, 31, 0.12);
    }

    .buy-item {
      .island {
        max-width: 254px;
        margin: 0 auto;
      }
    }

    .btn-green {
      margin-top: 1rem;
    }

    .egg {
      position: relative;
      z-index: 1;
      -webkit-transform-origin: center 80%;
      -webkit-animation: shake 2s infinite alternate;
      -webkit-transition: opacity 3s ease;
      width: 100px;
      margin-bottom: -4rem;
    }

    @keyframes wiggle {
      0% {
        transform: rotate(0);
      }
      5% {
        transform: rotate(3deg);
      }
      10% {
        transform: rotate(-3deg);
      }
      15% {
        transform: rotate(1deg);
      }
      25% {
        transform: rotate(-1deg);
      }
      30% {
       transform: rotate(-2deg);
      }
      35% {
        transform: rotate(2deg);
      }
      50% {
        transform: rotate(1deg);
      }
      60% {
        transform: rotate(-2deg);
      }
      75% {
        transform: rotate(1deg);
      }
    }
  }

  #nav {
    position: relative;
    background: #fff;
    padding-top: 2rem;
    padding-bottom: 2rem;

    .decor-border {
      position: absolute;
      top: -3rem;
    }
  }

  #why {
    background: #fff;
    padding-top: 2rem;

    .container {
      max-width: 800px;
    }

    img {
      max-width: 289px;
      margin: 0 auto;
    }

    h2 {
      text-transform: uppercase;
      font-size: 24px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: 2px;
      text-align: center;
      color: #6c6d69;
    }

    h3 {
      margin-top: 2rem;
      margin-bottom: 2rem;
      font-size: 32px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.25;
      letter-spacing: normal;
      text-align: center;
      color: #363734;
    }

    p {
      max-width: 588px;
      margin: 0 auto;
      font-size: 16px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;
      color: #6c6d69;
    }

    .rewards {
      max-width: 588px;
      margin: 0 auto;
      margin-top: 1rem;

      img {
        max-width: 124px;
      }

      .title {
        font-size: 14px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: center;
        color: #9bc75a;
      }

      p {
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: center;
        color: #a1a39e;
      }
    }
  }

  #perks {
    background: #fff;

    h2 {
      margin-bottom: 1rem;
      text-transform: uppercase;
      font-size: 24px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: 2px;
      text-align: center;
      color: #6c6d69;
    }

    .sub-title {
      margin-bottom: 2rem;
      font-size: 24px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      text-align: center;
      color: #a1a39e;
    }

    img {
      margin-right: 2rem;
      width: 32px;
      height: 32px;
    }

    p {
      font-size: 16px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
      color: #6c6d69;
      text-align: left;
    }
  }

  #getting-started {
    background: #fff;
    position: relative;
    padding-bottom: 5rem;

    .container {
      max-width: 800px;
    }

    .video-preview {
      width: 640px;
    }

    img {
      max-width: 100% !important;
    }

    .row {
      margin-bottom: 1rem;
    }

    h2 {
      text-transform: uppercase;
      font-size: 24px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: 2px;
      text-align: center;
      color: #6c6d69;
    }

    h3 {
      margin-top: 1rem;
      font-size: 24px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      color: #6c6d69;
    }

    p {
      width: 588px;
      margin: 1rem auto;
      font-size: 16px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;
      color: #6c6d69;
    }

    img {
      max-width: 640px;
    }

    .btn-green {
      width: 152px;
      margin: 0 auto;
    }

    .decor-border {
      position: absolute;
      bottom: 0rem;

      img {
        width: 100%;
        max-width: 100%;
      }
    }
  }
</style>

<script>
import Web3 from 'web3';
import MetamaskList from './metamask/MetamaskList';

let web3;
if (Web3.givenProvider) {
  web3 = new Web3(Web3.givenProvider);
}

const Eth = require('ethjs-query');
const EthContract = require('ethjs-contract');
const abi = require('../lib/presale.json');

// const address = '0xD626463959606063A3B15C336f88Bff063318dd0';
const address = '0x6C8c1A7957F25629517ce08978e02a56D069a5FB';

export default {
  name: 'Market',
  components: {
    MetamaskList,
  },
  data() {
    return {
      miniToken: {},
      currentEthAccount: '',
      loading: false,
    };
  },
  async mounted() {
    if (!web3) return;
    const eth = new Eth(web3.currentProvider);
    const contract = new EthContract(eth);
    const MiniToken = contract(abi);
    const miniToken = MiniToken.at(address);
    this.miniToken = miniToken;
    const accounts = await web3.eth.getAccounts();
    const currentAccount = accounts[0];
    this.currentEthAccount = currentAccount;
  },
  computed: {
    metaMaskAvailable() {
      return this.$store.state.metaMaskStatus;
    },
  },
  methods: {
    scrollTo(section) {
      document.querySelector(section)
        .scrollIntoView({
          behavior: 'smooth',
        });
    },
    async adopt() {
      this.loading = true;

      const transaction = await this.miniToken.adoptAxies(1, {
        from: this.currentEthAccount,
        value: web3.utils.toWei('0.05', 'ether'),
      });

      const interval = setInterval(() => {
        web3.eth.getTransaction(transaction, (err, response) => {
          if (err) {
            this.loading = false;
            clearInterval(interval);
            alert(err);
          }

          if (response && response.blockNumber) {
            this.loading = false;
            this.$router.push({ name: 'MySprites' });
            clearInterval(interval);
            alert('Success!');
          }
        });
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Market.vue